import axios from 'axios';

const clearCachedAuth = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('user');
};

const clearRoomCache = () => {
  localStorage.removeItem('event');
  localStorage.removeItem('ownersEvent');
  localStorage.removeItem('tags');
};

const isStoredAuthTokenValid = async () => {
  const authToken = localStorage.getItem('authToken');
  if (!authToken) {
    return false;
  }

  try {
    const response = await axios({
      url: `${process.env.REACT_APP_API_URL}/is_login`,
      method: 'POST',
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    return response.data?.is_login === true;
  } catch (error) {
    const status = error?.response?.status;

    if ([401, 403, 419].includes(status)) {
      return false;
    }

    // 認証確認自体が失敗した場合は、復旧不能と断定せず現在の認証情報を残す。
    return true;
  }
};

export const recoverFromFatalError = async ({
  loggedInMessage = 'エラーが発生しました。トップページに戻ります。',
  loggedOutMessage = 'エラーが発生しました。ログインの有効期限が切れた可能性があります。もう一度ログインしてください。',
  redirectTo = '/',
  loggedOutRedirectTo = './login',
} = {}) => {
  clearRoomCache();

  const authIsValid = await isStoredAuthTokenValid();
  if (!authIsValid) {
    clearCachedAuth();
    alert(loggedOutMessage);
    window.location.href = loggedOutRedirectTo;
    return;
  }

  alert(loggedInMessage);
  window.location.href = redirectTo;
};

export const clearRoomCacheAndGoTop = (message = 'エラーが発生しました。トップページに戻ります。') => {
  return recoverFromFatalError({
    loggedInMessage: message,
    redirectTo: '/',
  });
};
